import {
    SECTIONS,
    TIPO_ENTREGA_RETIRADA
} from '../../constants/configuracao-horarios';
/**
 * Action Types
 */

export const Types = {
    SELECT_SECTION: 'configuracoes/SELECT_SECTION',
    SELECT_TAB: 'configuracoes/SELECT_TAB',
    SELECT_SECTION_AND_TAB: 'configuracoes/SELECT_SECTION_AND_TAB'
};

/**
 * Reducer
 */

const INITIAL_STATE = {
    selectedSection: SECTIONS.CONFIGURAR_PEDIDOS,
    idTipoEntregaRetirada: TIPO_ENTREGA_RETIRADA.RETIRADA
};

export default function activeSection(state = INITIAL_STATE, action) {
    switch (action.type) {
        case Types.SELECT_SECTION:
            return {
                ...state,
                selectedSection: action.payload.selectedSection
            };
        case Types.SELECT_TAB:
            return {
                ...state,
                idTipoEntregaRetirada: action.payload.idTipoEntregaRetirada
            };
        case Types.SELECT_SECTION_AND_TAB:
            return {
                ...state,
                idTipoEntregaRetirada: action.payload.idTipoEntregaRetirada
            };

        default:
            return state;
    }
}

/**
 * Action Creators
 */

export const Creators = {
    selectSection: (payload) => {
        return {
            type: Types.SELECT_SECTION,
            payload
        };
    },
    selectTab: (payload) => {
        return {
            type: Types.SELECT_TAB,
            payload
        };
    }
};
